<template>
  <div>
    <b-modal id="modalEditISGprofileSettings" ref="modalEditISGprofileSettings" :title="$t('ISG profile')" hide-footer @shown="shown" size="lg">
      <div v-if="editItem">
        <b-tabs pills card>
          <b-tab :title="$t('Main')" active>
            <b-form-group label-align="right" v-if="editItem.id != 0" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.id" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                  {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Login type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.login_type" :options="loginType"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Password type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.password_type" :options="passwordType"/>
            </b-form-group>
            <b-form-group label-align="right" v-if="editItem.password_type === 2" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.static_password"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Authorisation timeout')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.session_time" aria-describedby="inputFeedbackTimeout" :state="editItem.session_time > 0"/>
              <b-form-invalid-feedback id="inputFeedbackTimeout">
                  {{ $t('Enter number') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Unlocked account code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.unblocked_account_code" :options="unlockedCode"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Blocked account code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.blocked_account_code" :options="blockedCode"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Assign address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="editItem.lease_address"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Switch types')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.switch_type_id" :options="switchTypes"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Set RADIUS parameters')">
            <b-row>
              <b-col style="margin:5px">
                <b-button variant="success" @click="swohAddRadiusAttr">{{ $t('Add') }}</b-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="ClickOnEditRadiusAttrButton(row)" id="transparent">
                  <b-img :src='editImage'/>
                </b-button>
                <b-button size="sm" @click.stop="deleteRadiusAttr(row)" id="transparent">
                  <b-img :src='deleteImage'/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="CoA">
            <b-row>
              <b-col style="margin:5px">
                <b-checkbox v-model="editItem.send_coa">{{ $t('Active') }}</b-checkbox>
                <b-button variant="success" :disabled="!editItem.send_coa" @click="swohAddRadiusAttrCoA">{{ $t('Add') }}</b-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="radiusAttrCoAItems" :fields="radiusAttrCoAFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="ClickOnEditRadiusAttrCoAButton(row)" id="transparent">
                  <b-img :src='editImage'/>
                </b-button>
                <b-button size="sm" @click.stop="deleteRadiusAttrCoA(row)" id="transparent">
                  <b-img :src='deleteImage'/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditISGprofileSettings.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isISGprofile="isISGprofile"
      :isEditRadiusAttr="isEditRadiusAttr"
      :isRadiusAttrCoa="isRadiusAttrCoa"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"
      :radiusAttrCoAItems="radiusAttrCoAItems"/>
    </b-modal>
  </div>
</template>

<script>
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'

export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    editItem: null
  },
  data () {
    return {
      isISGprofile: true,
      radiusAttr: {
        'set_object_id': 0,
        'set_type': 7,
        'attrs': []
      },
      radiusAttrCoA: {
        'set_object_id': 0,
        'set_type': 8,
        'attrs': []
      },
      isRadiusAttrCoa: false,
      radiusAttrCoAItems: [],
      radiusAttrCoAFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'service', label: this.$i18n.t('Service'), sortable: true},
        {key: 'event', label: this.$i18n.t('Event'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'service', label: this.$i18n.t('Service'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      passwordType: [
        {value: 1, text: this.$i18n.t('Password in IP group')},
        {value: 2, text: this.$i18n.t('Static')}
      ],
      loginType: [
        {value: 1, text: 'IP'},
        {value: 2, text: 'MAC'},
        {value: 3, text: this.$i18n.t('Login in IP group')},
        {value: 4, text: 'Custom login'},
        {value: 5, text: 'Option 82'}
      ],
      unlockedCode: [
        {value: 2, text: 'Access-Accept'},
        {value: 3, text: 'Access-Reject'}
      ],
      blockedCode: [
        {value: 2, text: 'Access-Accept'},
        {value: 3, text: 'Access-Reject'}
      ]
    }
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (!this.editItem.session_time) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Authorisation timeout fields is invalid'), 'Error')
        return
      }

      this.editItem.session_time = Number(this.editItem.session_time)
      if (this.editItem.password_type === 1) {
        this.editItem.static_password = ''
      }
      for (let el of this.radiusAttrItems) {
        el.properties[0].property_value = String(el.properties[0].property_value)
      }
      for (let el of this.radiusAttrCoAItems) {
        el.properties[0].property_value = String(el.properties[0].property_value)
      }
      this.editItem.isg_profile_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_ISG_PROFILE', this.editItem)
        : this.$store.dispatch('Settings/CREATE_ISG_PROFILE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          if (this.editItem.id) {
            this.radiusAttr.set_object_id = this.editItem.id
            this.radiusAttrCoA.set_object_id = this.editItem.id
          } else {
            this.radiusAttr.set_object_id = response.data.isg_profile_id
            this.radiusAttrCoA.set_object_id = response.data.isg_profile_id
          }
          this.radiusAttr.attrs = this.radiusAttrItems
          this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', this.radiusAttr)
          if (this.editItem.send_coa) {
            this.radiusAttrCoA.attrs = this.radiusAttrCoAItems
          } else {
            this.radiusAttrCoA.attrs = []
          }
          this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', this.radiusAttrCoA)
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ISG_PROFILE')
          this.$refs.modalEditISGprofileSettings.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      this.radiusAttrItems = []
      this.radiusAttrCoAItems = []
      if (this.editItem.id) {
        this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_ISG_PROFILE', this.editItem.id)
        this.radiusAttrItems = this.$store.getters['Tariffing/RADIUS_ATTR_ISG_PROFILE']
        for (let i in this.radiusAttrItems) {
          this.radiusAttrItems[i].value = this.radiusAttrItems[i].attr_value
          if (this.radiusAttrItems[i].properties[0].property_value === '') {
            this.radiusAttrItems[i].service = this.$i18n.t('All services')
          } else {
            for (let el of this.$store.getters['Tariffing/SERVICES']) {
              if (el.service_id === Number(this.radiusAttrItems[i].properties[0].property_value)) {
                this.radiusAttrItems[i].service = el.service_name + '(' + el.service_id + ')'
              }
            }
          }
          if (this.radiusAttrItems[i].tag) {
            this.radiusAttrItems[i].value = ':' + this.radiusAttrItems[i].tag + ':' + this.radiusAttrItems[i].attr_value
          }
          switch (this.radiusAttrItems[i].attr_type) {
            case 1:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Number')
              break
            case 2:
              this.radiusAttrItems[i].attrType = this.$i18n.t('String')
              break
            case 3:
              this.radiusAttrItems[i].attrType = 'IP'
              break
            case 4:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Binary')
              break
          }
        }
        this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_ISG_COA', this.editItem.id)
        this.radiusAttrCoAItems = this.$store.getters['Tariffing/RADIUS_ATTR_ISG_COA']
        for (let i in this.radiusAttrCoAItems) {
          this.radiusAttrCoAItems[i].value = this.radiusAttrCoAItems[i].attr_value
          if (this.radiusAttrCoAItems[i].properties[0].property_value === '') {
            this.radiusAttrCoAItems[i].service = this.$i18n.t('All services')
          } else {
            for (let el of this.$store.getters['Tariffing/SERVICES']) {
              if (el.service_id === Number(this.radiusAttrCoAItems[i].properties[0].property_value)) {
                this.radiusAttrCoAItems[i].service = el.service_name + '(' + el.service_id + ')'
              }
            }
          }
          switch (this.radiusAttrCoAItems[i].properties[1].property_value) {
            case '1':
              this.radiusAttrCoAItems[i].event = this.$i18n.t('Blocked')
              break
            case '0':
              this.radiusAttrCoAItems[i].event = this.$i18n.t('Unbloked')
              break
            case '':
              this.radiusAttrCoAItems[i].event = this.$i18n.t('All states')
              break
          }
          if (this.radiusAttrCoAItems[i].tag) {
            this.radiusAttrCoAItems[i].value = ':' + this.radiusAttrCoAItems[i].tag + ':' + this.radiusAttrCoAItems[i].attr_value
          }
          switch (this.radiusAttrCoAItems[i].attr_type) {
            case 1:
              this.radiusAttrCoAItems[i].attrType = this.$i18n.t('Number')
              break
            case 2:
              this.radiusAttrCoAItems[i].attrType = this.$i18n.t('String')
              break
            case 3:
              this.radiusAttrCoAItems[i].attrType = 'IP'
              break
            case 4:
              this.radiusAttrCoAItems[i].attrType = this.$i18n.t('Binary')
              break
          }
        }
      }
    },
    deleteRadiusAttrCoA (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrCoAItems = this.radiusAttrCoAItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    swohAddRadiusAttrCoA () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.isRadiusAttrCoa = true
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrCoAButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.isRadiusAttrCoa = true
      this.$refs.modalRadiusAttr.show()
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.isRadiusAttrCoa = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.isRadiusAttrCoa = false
      this.$refs.modalRadiusAttr.show()
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    }
  },
  computed: {
    switchTypes () {
      let res = this.$store.getters['Inventory/SWITCH_TYPES']
      let switchTypes = []
      for (let el of res) {
        let newSwitch = {
          value: 0,
          text: ''
        }
        newSwitch.value = el.id
        newSwitch.text = el.name
        switchTypes.push(newSwitch)
      }
      return switchTypes
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/ISG/ISGprofile/editModal.vue